<a
  [routerLink]="route()"
  class="sidebar-nav-item"
  [class.is-active]="isActive()"
  [class.is-collapsed]="collapsed()"
  [attr.aria-current]="isActive() ? 'page' : null"
  [attr.aria-label]="label()"
  [attr.title]="collapsed() ? label() : null"
>
  <lucide-icon [name]="icon()" [size]="16" class="item-icon"></lucide-icon>
  @if (!collapsed()) {
    <span class="item-label">{{ label() }}</span>
    @if (badgeCount() > 0) {
      <span class="item-badge">{{ badgeCount() }}</span>
    }
  } @else if (badgeCount() > 0) {
    <span class="item-dot"></span>
  }
</a>
